import { getModuleFederatedName, setupServiceInfo } from '@estee/elc-universal-utils';
import { ServiceManager } from '@estee/elc-service';
import { AUTO_REPLENISH } from '@estee/elc-service-view-names';
import serviceNames, { SubscriptionsService } from '~setup/SubscriptionsService';

import './exported/auto-replenishment/index';

setupServiceInfo(__serviceInfo__);
const { name, version } = __serviceInfo__;

SubscriptionsService.setViews(name, getModuleFederatedName(name), version, [AUTO_REPLENISH]);

ServiceManager.setServiceStartParams({
    serviceName: name,
    diContainerImport: () => import('~setup/diContainer'),
    serviceKey: serviceNames.subscriptionsService
});
